"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "apice": {
    "b015da31": [{
      "hkey": "c158a2ad",
      "slug": "apice-nuovo",
      "name": "Apice Nuovo",
      "primary": true,
      "skipSearch": false
    }],
    "apice-nuova": [{
      "hkey": "c158a2ad",
      "slug": "apice-nuovo",
      "name": "Apice Nuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d5d12d0f": [{
      "hkey": "b9042552",
      "slug": "apice-vecchio",
      "name": "Apice Vecchio",
      "primary": true,
      "skipSearch": false
    }],
    "apice-vecchia": [{
      "hkey": "b9042552",
      "slug": "apice-vecchio",
      "name": "Apice Vecchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6d092e25": [{
      "hkey": "3feddc4f",
      "slug": "apice",
      "name": "Apice",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-rotto": [{
      "hkey": "3feddc4f",
      "slug": "apice",
      "name": "Apice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f28810a9": [{
      "hkey": "3feddc4f",
      "slug": "apice",
      "name": "Apice",
      "primary": true,
      "skipSearch": false
    }],
    "tufo": [{
      "hkey": "3feddc4f",
      "slug": "apice",
      "name": "Apice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2a18dbdd": [{
      "hkey": "3feddc4f",
      "slug": "apice",
      "name": "Apice",
      "primary": true,
      "skipSearch": false
    }],
    "vernacchio": [{
      "hkey": "3feddc4f",
      "slug": "apice",
      "name": "Apice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2368897": [{
      "hkey": "3feddc4f",
      "slug": "apice",
      "name": "Apice",
      "primary": true,
      "skipSearch": false
    }],
    "frattolillo": [{
      "hkey": "3feddc4f",
      "slug": "apice",
      "name": "Apice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;